import Icon from '../../components/Icon.vue'

Icon.register({"brands/creative-commons-nd":{"width":496,"height":512,"paths":[{"d":"M247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7zM342.4 197V239.5H162.1V197H342.4zM342.4 276.8V319.3H162.1V276.8H342.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-nd.js
// module id = HYZs
// module chunks = 0